define(['underscore'], (_)=> {
    return {
        /** "Safer" version of accessor which retrieves object's own properties only. */
        'get': (map, prop)=> {
            if (!_.has(map, prop)) {
                return;
            }

            return map[prop];
        },

        /**
         * Converts items list into the unique map.
         * @param items items to convert into the map.
         * @param keyFunctionOrProperty function used to access a key or name of the key property.
         * @return map from key to object.
         * @throws Error if key is not unique.
         */
        'toUniqueMap': (items, keyFunctionOrProperty)=> {
            const res = {};
            const keyFunction =
                _.isFunction(keyFunctionOrProperty) ? keyFunctionOrProperty : _.property(keyFunctionOrProperty);
            items.forEach((item)=> {
                const key = keyFunction(item);
                if (_.has(res, key)) {
                    throw new Error(`Duplicate key ${key} found`);
                }
                res[key] = item;
            });
            return res;
        }
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/util/MapUtil.js